import { render, staticRenderFns } from "./FormResponseType2.vue?vue&type=template&id=5b7a258d&scoped=true&"
import script from "./FormResponseType2.vue?vue&type=script&lang=js&"
export * from "./FormResponseType2.vue?vue&type=script&lang=js&"
import style0 from "./FormResponseType2.vue?vue&type=style&index=0&id=5b7a258d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7a258d",
  null
  
)

export default component.exports